import React from 'react';
import {
  ChatBubbleLeftRightIcon,
  RectangleGroupIcon,
  Squares2X2Icon,
} from '@heroicons/react/24/outline';
import {
  AE_BUILDER_QUESTION_ICON,
  AE_BUILDER_SECTION_ICON,
  AE_BUILDER_SUBSECTION_ICON,
  AE_ICON_SIZE,
} from '@/components/assessment-engine/layout/aeTheme';

export type BuilderEntityKind = 'section' | 'subsection' | 'question';

interface BuilderEntityIconProps {
  kind: BuilderEntityKind;
  className?: string;
}

/** Consistent section / subsection / question icons using TMOS theme tokens. */
export const BuilderEntityIcon: React.FC<BuilderEntityIconProps> = ({ kind, className }) => {
  const sizeClass = className ?? AE_ICON_SIZE;
  if (kind === 'section') {
    return (
      <RectangleGroupIcon
        className={`${sizeClass} ${AE_BUILDER_SECTION_ICON}`}
        aria-hidden
      />
    );
  }
  if (kind === 'subsection') {
    return (
      <Squares2X2Icon
        className={`${sizeClass} ${AE_BUILDER_SUBSECTION_ICON}`}
        aria-hidden
      />
    );
  }
  return (
    <ChatBubbleLeftRightIcon
      className={`${sizeClass} ${AE_BUILDER_QUESTION_ICON}`}
      aria-hidden
    />
  );
};
